export const baseUrl =
  import.meta.env.VITE_BASE_URL || 'http://localhost:8080/';
export const APIUrl =
  import.meta.env.VITE_API_URL || 'http://localhost:8080/query';
export const WSUrl = import.meta.env.VITE_WS_URL || 'ws://localhost:8080/query';
